import React from "react";
import { StyleSheet, TextInput } from "react-native";
type Props = {
  style?: any;
  secureTextEntry?: boolean;
  autoFocus?: boolean;
  type?: string;
  value?: string;
  autoCapitalize?: string;
  onChangeText?: (text: string) => void;
};
export default function FormTextInput(props: Props) {
  return <TextInput {...props} style={[styles.textInput, props.style]} />;
}
const styles = StyleSheet.create({
  textInput: {
    height: 30,
    backgroundColor: "white",
    borderWidth: 1,
    borderColor: "grey",
  },
});
